export const sysAdminCreatePath = () => `/sys_admins/new`;
export const tenantCreatePath = () => `/tenants/new`;
export const twilioPhoneNumberCreatePath = () => `/twilio_phone_numbers/new`;
export const jobShowPath = (id, apptId = 0) => {
  return apptId ? `/jobs/${id}?appointment_id=${apptId}` : `/jobs/${id}`;
};
export const technicianShowPath = (id) => `/technicians/${id}`;
export const technicianCreatePath = (departmentId) =>
  `/departments/${departmentId}/technicians/new`;
export const scheduleAppointmentPath = (addressId, customerId) =>
  `/jobs/schedule_appointment?address_id=${addressId}&customer_id=${customerId}`;
export const permitNewPath = (jobId) => `/permits/new?permit[job_id]=${jobId}`;
export const permitShowPath = (id) => `/permits/${id}`;
export const userShowPath = (id) => `/customers/${id}`;
export const subCustomersPath = (id) => `/customers/${id}?tab=c_Sub-Customers`;
export const userCreatePath = () => `/customers/new`;
export const adminShowPath = (id) => `/admins/${id}`;
export const adminCreatePath = () => `/admins/new`;
export const membershipProgramShowPath = (id) => `/membership_programs/${id}`;
export const membershipProgramIndexPath = () => `/programs?tab=pg_memberships`;
export const membershipProgramNewPath = () => `/membership_programs/new`;
export const warrantyProgramShowPath = (id) => `/warranty_programs/${id}`;
export const warrantyProgramIndexPath = () => `/programs?tab=pg_warranties`;
export const warrantyProgramNewPath = () => `/warranty_programs/new`;
export const scheduleBoardAppointmentModal = (appointmentId, date) =>
  `/?appointment_id=${appointmentId}&start=${date}`;
export const invoiceShowPath = (invoice) =>
  `/customers/${invoice.customer_id}?tab=c_Invoices&invoice_id=${invoice.id}`;
export const polymorphicUserPath = ({ type, id }) => {
  switch (type) {
    case "admin":
      return adminShowPath(id);
    case "technician":
      return technicianShowPath(id);
    case "customer":
      return userShowPath(id);
    default:
      return;
  }
};
